import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const REAL_PHOTOS = [{
  src: 'https://cdn.magicpatterns.com/uploads/33vHLTnabL2uWLAhXboGLX/WhatsApp_Image_2026-05-11_at_12.47.39_PM.jpg',
  alt: 'Lector con la colección Placer, Culpa y Vacío'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2duFZvKRHuDgQCEyYS5XDK/ChatGPT_Image_21_may_2026,_17_32_32.png',
  alt: 'Lectora mostrando el libro en tablet'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/n5SmhhXUy7yTLa4qJ7ssum/ChatGPT_Image_21_may_2026,_17_21_20.png',
  alt: 'Lectora con el libro impreso'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/srchCqeYXqiXcrdQHvuR21/ChatGPT_Image_21_may_2026,_17_00_38.png',
  alt: 'Lector en el parque con el libro'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6UAhpKA3BGsiDx5nNqfcnM/ChatGPT_Image_21_may_2026,_16_26_25.png',
  alt: 'Lectora abrazando el libro en la cama'
}];
export function PainSection() {
  const painPoints = [{
    icon: '🔄',
    text: 'Caíste de nuevo en lo que prometiste no hacer — y lo peor no fue el acto, sino la culpa que vino después.'
  }, {
    icon: '😶',
    text: 'Eres funcional, "tienes todo bajo control" — pero hay algo que jala en otra dirección y que no puedes explicarle a nadie.'
  }, {
    icon: '💪',
    text: 'Probaste fuerza de voluntad, apps, libros, promesas contigo mismo/a. Funcionó por un tiempo. El ciclo volvió.'
  }, {
    icon: '🪤',
    text: 'Sientes que cuanto más tiempo llevas en esto, más difícil se hace creer que algo puede ser diferente.'
  }, {
    icon: '😔',
    text: 'La culpa que sientes después no te protege de la próxima recaída. Te prepara para ella.'
  }];
  const [photoIdx, setPhotoIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setPhotoIdx(i => (i + 1) % REAL_PHOTOS.length);
    }, 3500);
    return () => clearInterval(id);
  }, []);
  return <section className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_top_right,rgba(194,0,111,0.15)_0%,transparent_60%),var(--dark-bg)]" data-id="element-148" data-mp="p4logy546svf">
      <div className="max-w-[900px] mx-auto" data-id="element-149" data-mp="u12a9loucv5c">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-150" data-mp="yt3npaxqwrwy">
          ¿Te identificas?
        </span>

        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-151" data-mp="12x1odq2pyas4">
          ¿Cuántas veces dijiste
          <br data-id="element-152" data-mp="b39b8uhc95d8" />
          <span className="text-gradient-magenta" data-id="element-153" data-mp="b4u50hvtwka1">"nunca más"</span> —<br data-id="element-154" data-mp="f5w5t35e94e4" />y
          volviste a caer igual?
        </h2>

        <ul className="list-none mt-3 mb-3 space-y-2" data-id="element-155" data-mp="f4bcfgutfrhu">
          {painPoints.map((point, idx) => <li key={idx} className="flex items-start gap-3 py-3 px-4 bg-[rgba(194,0,111,0.08)] border border-[rgba(194,0,111,0.2)] border-l-4 border-l-magenta rounded-[10px] text-[0.95rem] leading-[1.5] text-white/85 transition-all duration-300 hover:bg-[rgba(194,0,111,0.15)] hover:border-l-magenta-bright hover:translate-x-[5px]" data-id="element-156" data-mp="k60liqyh9v3a" data-mpi={idx}>
              <span className="text-[1.4rem] shrink-0 mt-[2px]" data-id="element-157" data-mp="20q16ah8nn8fk">
                {point.icon}
              </span>
              <span data-id="element-158" data-mp="1vw6s1tbtjlnv">{point.text}</span>
            </li>)}
        </ul>

        <div className="bg-gradient-to-br from-[rgba(107,0,182,0.3)] to-[rgba(194,0,111,0.2)] border border-[rgba(194,0,111,0.4)] rounded-2xl py-4 px-5 mt-3 text-center" data-id="element-159" data-mp="1rvmuionc2g17">
          <blockquote className="font-heading font-bold text-[clamp(1rem,2.5vw,1.35rem)] leading-[1.45] text-white" data-id="element-160" data-mp="1hxp723dasn9n">
            "El ciclo no persiste porque seas débil.
            <br data-id="element-161" data-mp="1d0yrdh5entor" />
            Persiste porque{' '}
            <em className="text-magenta-bright not-italic" data-id="element-162" data-mp="18yllmsqnrvrz">
              nadie te dio las herramientas para interrumpirlo.
            </em>
            "
          </blockquote>
        </div>

        {/* Real People Carousel — Social proof */}
        <div className="mt-6" data-id="element-163" data-mp="339qo3tq0e25q">
          <h3 className="font-heading font-bold text-[0.9rem] tracking-[2px] uppercase text-white/50 mb-3 text-center" data-id="element-164" data-mp="3ae9q4lqx763e">
            Personas reales con el libro
          </h3>

          <div className="relative max-w-[320px] mx-auto" data-id="element-165" data-mp="31e3cmzv82648">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-magenta/30 shadow-[0_15px_50px_rgba(194,0,111,0.35),0_0_30px_rgba(107,0,182,0.25)] bg-card-bg" data-id="element-166" data-mp="31djtxgxqzdp5">
              <AnimatePresence mode="wait" data-id="element-167" data-mp="2rni7etl1m3cc">
                <motion.img key={photoIdx} src={REAL_PHOTOS[photoIdx].src} alt={REAL_PHOTOS[photoIdx].alt} initial={{
                opacity: 0,
                scale: 1.03
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.98
              }} transition={{
                duration: 0.7,
                ease: 'easeInOut'
              }} className="absolute inset-0 w-full h-full object-cover" data-id="element-168" data-mp="2wf077ebbxxvq" />
              </AnimatePresence>

              {/* Subtle gradient overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" data-id="element-169" data-mp="1z1tnjwab9xfl" />

              {/* Verified badge */}
              <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-black/60 backdrop-blur-sm border border-white/10 rounded-full py-1 px-2.5" data-id="element-170" data-mp="2czi5av930ogf">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-171" data-mp="2mqct441z7w3z" />
                <span className="text-[0.65rem] text-white/85 font-heading font-bold tracking-wide uppercase" data-id="element-172" data-mp="2hs1jnuflfnma">
                  Foto real
                </span>
              </div>
            </div>

            {/* Progress dots */}
            <div className="flex items-center justify-center gap-2 mt-4" data-id="element-173" data-mp="2qukh1z0m1815">
              {REAL_PHOTOS.map((_, idx) => <button key={idx} type="button" onClick={() => setPhotoIdx(idx)} aria-label={`Ver foto ${idx + 1}`} className={`h-1.5 rounded-full transition-all duration-300 ${idx === photoIdx ? 'w-6 bg-magenta-bright' : 'w-1.5 bg-white/25 hover:bg-white/45'}`} data-id="element-174" data-mp="1odqoy7v2pqmr" data-mpi={idx} />)}
            </div>
          </div>
        </div>

        {/* Customer Reviews */}
        <div className="mt-6" data-id="element-175" data-mp="2c3uwgqbduaj1">
          <h3 className="font-heading font-bold text-[0.9rem] tracking-[2px] uppercase text-white/50 mb-3 text-center" data-id="element-176" data-mp="2c6z45xo23oeg">
            Lo que dicen quienes ya lo tienen
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-177" data-mp="2l51beuydvda6">
            {/* Review 1 - Camila - 5 stars */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-all duration-300 hover:border-magenta/30" data-id="element-178" data-mp="mskkhrrwarpt">
              <div className="flex items-center gap-2 mb-2" data-id="element-179" data-mp="j8k3ayys6iu7">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-180" data-mp="ja50yxge6hwa">
                  ★★★★★
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-181" data-mp="9hpi7xx9tpac">
                "Lo leí en una noche. Por primera vez entendí por qué me pasaba
                lo que me pasaba. Lloré, pero de alivio."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60" data-id="element-182" data-mp="126d7e4l54yt6">
                — Camila R.
              </p>
            </div>

            {/* Review 2 - Martín - 4 stars */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-all duration-300 hover:border-magenta/30" data-id="element-183" data-mp="t4wwzwubswoy">
              <div className="flex items-center gap-2 mb-2" data-id="element-184" data-mp="3dwp6j774mzsp">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-185" data-mp="3dy0dffvvcno1">
                  ★★★★<span className="text-white/20" data-id="element-186" data-mp="38wkubtd94r8a">★</span>
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-187" data-mp="1cteq6j54tb4a">
                "Pensé que era otro libro de autoayuda genérico. Me equivoqué.
                Es directo, sin rodeos y funciona."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60" data-id="element-188" data-mp="12y4jhi3sgfk6">
                — Martín L.
              </p>
            </div>

            {/* Review 3 - Diego - 5 stars */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-all duration-300 hover:border-magenta/30" data-id="element-189" data-mp="1vlqz5oqajane">
              <div className="flex items-center gap-2 mb-2" data-id="element-190" data-mp="1lvfhkzdop2y1">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-191" data-mp="1luw1zpbiaqn6">
                  ★★★★★
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-192" data-mp="2ek37x9daiiig">
                "Llevo 3 semanas aplicando el método y la diferencia es real.
                Ojalá lo hubiera encontrado antes."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60" data-id="element-193" data-mp="7uj4p0t9i6k6">
                — Diego M.
              </p>
            </div>

            {/* Review 4 - Valentina - 4 stars */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-all duration-300 hover:border-magenta/30" data-id="element-194" data-mp="gmtfokbzeg2h">
              <div className="flex items-center gap-2 mb-2" data-id="element-195" data-mp="codwysmxntuv">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-196" data-mp="3l34ba3ehrggp">
                  ★★★★<span className="text-white/20" data-id="element-197" data-mp="3g3jcbszbn83z">★</span>
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-198" data-mp="3u3am1hit22c6">
                "Me dio herramientas concretas, no frases vacías. Lo recomiendo
                a cualquiera que sienta que no puede solo/a."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60" data-id="element-199" data-mp="19az015z4i31s">
                — Valentina S.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}